<script>
  import ValidationMessage from '../../../../../components/form/ValidationMessage.vue'
  import PaperShowScreening from './Screening.vue'
  import PaperShowEvaluation from './Evaluation.vue'
  import helpers from '@mixins/helper'

  import {required, minLength} from 'vuelidate/lib/validators'
  import {orderBy} from 'lodash'

  export default {
    components: {ValidationMessage, PaperShowScreening, PaperShowEvaluation},
    mixins: [helpers],
    props: ['model', 'loadList'],
    data () {
      return {
        isSubmitted: false,
        isPaperVisible: false,
        isSearchingAppraiser: false,
        paper: {
          notes: ''
        },
        dependencies: {
          appraisers: [],
          filteredAppraisers: []
        },
        appraisers: []
      }
    },
    mounted () {
      this.model.contents = orderBy(this.model.contents, ['event_paper_type_field.field.type'], ['desc'])
      this.paper = this.model
      setTimeout(() => {
        this.isPaperVisible = true
      }, 500)
    },
    computed: {
      paperStatusKey: function () {
        return this.paper.status.key
      },
      showPaperPreview: function () {
        return this.paperStatusKey === 'nao_designado'
      },
      getPaperFilePath: function () {
        return this.paper.file ? this.paper.file.show_file_path : ''
      }
    },
    validations: function () {
      return {
        paper: {
          notes: {required}
        },
        appraisers: {
          required,
          minLength: minLength(this.showEvaluations ? 1 : (this.paper.event_paper_type.evaluation_type ? this.minEvaluations : 0)),
          $each: {
            appraiser_id: {required}
          }
        }
      }
    }
  }
</script>

<template>
    <div v-if="isPaperVisible" style="padding-bottom: 200px;">
        <hr>
        <h2>Visualizando os dados da Submissão #{{paper.id}}</h2>
        <el-row :gutter="20" class="registration-data submission-data">
            <el-col :span="10">
                <table class="table-confirmation">
                    <thead>
                    <tr>
                        <th colspan="2">Dados da Submissão</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <strong>Tipo de Trabalho:</strong> {{paper.event_paper_type.paper_type.name}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div><strong>Submetido por:</strong> {{paper.registration.person.pessoa.nome}}
                                ({{paper.registration.person.ref_pessoa}})
                            </div>
                            <div><strong>Data da Submissão:</strong> {{paper.date_submitted | dateTimeEnToBr}}</div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div><strong>Status:</strong> {{paper.status.name}}</div>
                            <div><strong>Data da últ. atualização:</strong> {{paper.last_modified | dateTimeEnToBr}}
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <table class="table-confirmation" style="table-layout: fixed">
                    <thead>
                    <tr>
                        <th>Dados do Trabalho</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="paper.knowledge_area">
                        <td>
                            <strong>Área do Conhecimento:</strong> {{paper.knowledge_area.full_name}}
                        </td>
                    </tr>
                    <tr v-for="content in paper.contents">
                        <td v-if="content.event_paper_type_field.field.type !== 'file'" class="dont-break-out">
                            <strong>{{content.event_paper_type_field.field.name}}:</strong> {{content.value}}
                        </td>
                        <td v-if="content.event_paper_type_field.field.type === 'file'"
                            v-bind:class="{'-missing-file': content.value === ''}" class="dont-break-out">
                            <span v-if="content.value && content.value !== ''">
                                <strong>{{content.event_paper_type_field.field.name}}:</strong> {{content.value}} <span
                                    class="paper-content-file-version">(Versão: {{content.version}})</span>
                            </span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </el-col>
            <el-col :span="14">
                <table class="table-confirmation">
                    <thead>
                    <tr>
                        <th colspan="2">Autores</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="author in paper.authors">
                        <td>
                            <div>
                                <strong>{{author.author_type.name}} {{author.seq}}</strong>
                                <span v-if="author.primary_contact"> - Contato Principal</span>
                            </div>
                            <div>
                                <strong>Nome Completo:</strong> {{author.first_name + ' ' + author.last_name}}
                            </div>
                            <div><strong>Email:</strong> {{author.email}}</div>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <paper-show-screening v-if="paper"
                                      :paper="paper"/>

                <paper-show-evaluation v-if="paper"
                                      :paper="paper"/>

            </el-col>
        </el-row>
        <div v-if="showPaperPreview">
            <h3>Preview do Trabalho</h3>
            <object :data="getPaperFilePath"
                    v-if="getPaperFilePath"
                    type="application/pdf">
                <embed :src="getPaperFilePath"
                       type="application/pdf"/>
            </object>
            <div v-else>
                Arquivo não encontrado
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .helper-text {
        color: rgba(166, 28, 0, 0.89);
        font-weight: bold;
        font-size: 12px;
        padding-left: 5px;
    }

    .el-select-appraisers {
        height: auto !important;
        line-height: normal !important;
        padding: 5px 20px !important;
        .item-description {
            font-size: 13px;
            padding-top: 4px;
        }
    }

    .table-confirmation td > .table-confirmation {
        margin-bottom: 0;
    }

    .table-evaluations {
        thead th {
            background-color: rgba(240, 225, 198, 0.4);
        }
        .table-confirmation {
            th, td {
                padding: 5px 10px;
                font-size: 14px;
            }
        }
    }

    #paper-content {
        padding-top: 80px;
        object,
        embed {
            width: 100%;
            height: 700px;
        }
        object {
            border: 1px solid #CCC;
            margin-bottom: 20px;
        }
    }

    .dont-break-out {
        /* These are technically the same, but use both */
        overflow-wrap: break-word;
        word-wrap: break-word;

        -ms-word-break: break-all;
        /* This is the dangerous one in WebKit, as it breaks things wherever */
        word-break: break-all;
        /* Instead use this non-standard one: */
        word-break: break-word;

        /* Adds a hyphen where the word breaks, if supported (No Blink) */
        -ms-hyphens: auto;
        -moz-hyphens: auto;
        -webkit-hyphens: auto;
        hyphens: auto;
    }
</style>



// WEBPACK FOOTER //
// PaperShow.vue?45f0bfc8